import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeRoutineModal,
  saveRoutine,
  selectEditingRoutine,
  selectLoading
} from '../../features/adminSlice';

const AdminRoutineModal = () => {
  const dispatch = useDispatch();
  const routine = useSelector(selectEditingRoutine);
  const loading = useSelector(selectLoading);

  const [definition, setDefinition] = useState('');

  useEffect(() => {
    if (routine?.definition) {
      setDefinition(routine.definition);
    }
  }, [routine]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(saveRoutine({ oid: routine.oid, definition }));
  };

  const handleClose = () => {
    dispatch(closeRoutineModal());
  };

  if (!routine) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="bg-[#111827] rounded-lg border border-gray-800 w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-800 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold font-mono">{routine.routine_name}</h3>
            <span className="text-xs text-gray-400">
              {routine.routine_type} · {routine.language}
              {routine.arguments && ` · (${routine.arguments})`}
            </span>
          </div>
          <button
            onClick={handleClose}
            disabled={loading}
            className="p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded transition-colors disabled:opacity-50"
          >
            <span className="material-icons">close</span>
          </button>
        </div>

        {/* Editor */}
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6">
          <textarea
            value={definition}
            onChange={(e) => setDefinition(e.target.value)}
            disabled={loading}
            spellCheck={false}
            className="w-full h-full min-h-[480px] bg-[#0A0F1A] border border-gray-700 rounded-lg px-4 py-3 text-white font-mono text-sm leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#44C2FD] disabled:opacity-50 resize-none"
          />
        </form>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-800 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="px-4 py-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-gradient-to-r from-[#44C2FD] to-[#23A6D5] text-white font-medium rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center gap-2"
          >
            {loading && (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            )}
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminRoutineModal;
